import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/types';
import { ARIA_CHAT_ENABLED_STAGES } from './ariaChatConstants';

/**
 * Whether the Aria chat widget is shown in the current stage (from settings.json). It's hidden while
 * the stage is still loading, so it never flashes up in stages where it's disabled.
 */
export const useAriaChatEnabled = (): boolean => {
    const stage = useSelector((state: RootState) => state.systemReducer.stage.value);
    return !!stage && ARIA_CHAT_ENABLED_STAGES.includes(stage);
};
